module.exports = __webpack_public_path__ + "static/headshot-lauren-pearl-3x.1bdb70c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-lauren-pearl-3x.jpg
// module id = 124
// module chunks = 35783957827783 152909308826437